import { render, staticRenderFns } from "./DtsTimeStreamax.vue?vue&type=template&id=37e79c04&scoped=true&"
import script from "./DtsTimeStreamax.vue?vue&type=script&lang=ts&"
export * from "./DtsTimeStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./DtsTimeStreamax.vue?vue&type=style&index=0&id=37e79c04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e79c04",
  null
  
)

export default component.exports